export var warn = function warn(component) {
  var _console;

  for (var _len = arguments.length, message = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    message[_key - 1] = arguments[_key];
  }

  return (// eslint-disable-next-line no-console
    (_console = console).warn.apply(_console, ['@tourlane/tourlane-ui:', "<" + component + ">:"].concat(message))
  );
};
export var error = function error(component) {
  var _console2;

  for (var _len2 = arguments.length, message = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    message[_key2 - 1] = arguments[_key2];
  }

  return (// eslint-disable-next-line no-console
    (_console2 = console).error.apply(_console2, ['@tourlane/tourlane-ui:', "<" + component + ">:"].concat(message))
  );
}; // eslint-disable-next-line no-console

export var log = function log() {
  var _console3;

  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return (_console3 = console).log.apply(_console3, ['@tourlane/tourlane-ui:'].concat(args));
};